import React from 'react';
import { Routes as RouterRoutes, Route, Navigate } from 'react-router-dom';
import { AUTHENTICATED_ENTRY } from 'configs/AppConfig';
import { protectedRoutes, publicRoutes } from 'configs/RoutesConfig';
import ProtectedRoute from './ProtectedRoute';
import PublicRoute from './PublicRoute';
import AppRoute from './AppRoute';
import ChatAgentIframe from 'views/app-views/chat-agent-iframe/ChatAgentIframe';

// Lazy load OAuth callback components

const Routes = () => {

	return (
		<RouterRoutes>
			{/* Public routes - no authentication required */}
			{publicRoutes.map(route => {
				return (
					<Route
						key={route.path}
						path={route.path}
						element={
							<PublicRoute>
								<AppRoute
									routeKey={route.key}
									component={route.component}
									premiumRequired={route.meta?.premiumRequired}
									{...route.meta}
								/>
							</PublicRoute>
						}
					/>
				)
			})}

			{/* Protected routes - authentication required */}
			<Route path="/" element={<ProtectedRoute />}>
				<Route path="/" element={<Navigate replace to={AUTHENTICATED_ENTRY} />} />
				{protectedRoutes.map((route, index) => {
					return (
						<Route
							key={route.key + index}
							path={route.path}
							element={
								<AppRoute
									routeKey={route.key}
									component={route.component}
									premiumRequired={route.meta?.premiumRequired}
									{...route.meta}
								/>
							}
						/>
					)
				})}
				<Route path="*" element={<Navigate to="/" replace />} />
			</Route>
		</RouterRoutes>
	)
}

export default Routes